module.exports = __webpack_public_path__ + "static/media/twitter.6a073f68.svg";